// ======== plugin import ========= //
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
// ======== component import ========= //
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent';
const PlHowItsWorks = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className="col-md-12 text-center mb-20">
                <SectionHeader_2
                    title= {`How it works?`}
                    subTitle={`Making a fully AI powered Virtual Agent has never been so easy!`}
                    
                />
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Auto NLU Training
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                        <li className="d-flex text-gray-700 fs-3">
                            <FontAwesomeIcon icon={faCircleCheck} className="me-2 mt-1" />
                            <div>
                                <div>
                                TruVoice Generative AI <sup style={{ fontSize: '0.6em', verticalAlign: 'baseline', position: 'relative', top: '-0.9em' }}>‘Pat.Pend.’</sup>
                                &nbsp;generates training data based on the examples that you provide. While you sit back and relax.
                                </div>
                            </div>
                        </li>
                        <li className='d-flex text-gray-700 fs-3'>
                            <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                            After that, you can test the model and add, modify examples and retrain to improve.
                        </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto'>
                    <img src="/assets/img/tvicon/nlu.png" alt="app image" className="radius-20 p-10 pe-0 w-80" style={{}} />
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-4 pe-15 m-auto'>
                    <img src="/assets/img/tvicon/conversations.png" alt="app image" className="radius-20 p-10 ps-0 w-80" style={{}} />
                </div>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Seamless conversations without you knowing it!
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                TruVoice Dialogue Engine already knows how to respond to any unexpected (or) out of scope conversations. See it for yourself once to deploy an agent.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        AI Agents which fulfil service requests.
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Sales AI agents which can consult on product inquiries, collect orders and payments, assign for shipment, and issue tracking numbers.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Service AI agents which can clarify the requests with the customer, login the requests into CRM, route to necessary departments, or fix an appointment and so on.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Tech support, HR screening or any avatar that you may need!
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto'>
                    <img src="/assets/img/tvicon/agents.png" alt="app image" className="radius-20 p-10 pe-0 w-80" style={{}} />
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-4 pe-15 m-auto'>
                    <img src="/assets/img/tvicon/easy-ui.png" alt="app image" className="radius-20 p-10 ps-0 w-80" style={{}} />
                </div>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Easy and intuitive UI
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                No complex flows
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                No dragging and dropping nodes
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                As intuitive as it can get
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Just type-in what you need, and TruVoice will do the rest.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Built-in General Conversations
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                All general-purpose intents such as greetings, pause, thanking etc., are pre-built. Just select those which you want for your Agent.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Optionally, you can integrate any LLM, or NLU models.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto'>
                    <img src="/assets/img/tvicon/general.png" alt="app image" className="radius-20 p-10 pe-0 w-80" style={{}} />
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-4 pe-15 m-auto'>
                    <img src="/assets/img/tvicon/integrate.png" alt="app image" className="radius-20 p-10 ps-0 w-80" style={{}} />
                </div>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Integrate with 3rd party systems
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Easy integrations with any CRM or Payment Gateway or other systems, through our universal API end points.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Custom built API integrations available on request.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Integrate with any channel
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className="d-flex text-gray-700 fs-3">
                                <FontAwesomeIcon icon={faCircleCheck} className="me-2 mt-1" />
                                <span>
                                    You get&nbsp;
                                    <u style={{ margin: '0 4px' }}>
                                    TruChat Widget<sup style={{ fontSize: '0.7em', verticalAlign: 'baseline', position: 'relative', top: '-0.5em' }}>&nbsp;®</sup>
                                    </u>
                                    &nbsp;by default. Simply add it to any web page you like.
                                </span>
                            </li>

                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Easy integrations with WhatsApp, Telegram, Facebook or any other channel via our universal API end points.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Easy integrations with any Speech to text, Text to speech, SIP or other channels via universal API end points.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto'>
                    <img src="/assets/img/tvicon/any-channel.png" alt="app image" className="radius-20 p-10 pe-0 w-80" style={{}} />
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-20'>
                <div className='col-md-4 pe-15 m-auto'>
                    <img src="/assets/img/tvicon/performance.png" alt="app image" className="radius-20 p-10 ps-0 w-80" style={{}} />
                </div>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Performance monitoring and reporting
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Access logs from developers console to understand how you Agent is performing.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Pre-built live reporting module.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You can use our <u style={{ margin: '0 4px', display: 'inline-block' }}>Reporting APIs</u> to integrate with other reports.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {PlHowItsWorks}